var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    transform: "rotate(-90 8 8)",
    stroke: "url(#paint0_linear_17_1192)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9171 5.08325L5.08374 10.9166M5.08374 5.08325L10.9171 10.9166",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_1192",
    x1: -9.53674e-7,
    y1: 16,
    x2: 17.0186,
    y2: 14.8312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12A7FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup72);
export default __webpack_public_path__ + "static/media/Group 72.84eef36351248d9cbec614c05af28b34.svg";
export { ForwardRef as ReactComponent };